import { DSCustomElement } from "../core-types";

export function setupShadowDOM(
    dashedName: string,
    css: string = ''
): (element: DSCustomElement) => HTMLElement {
    let fragment: DocumentFragment;

    const canTemplate = !!window.HTMLTemplateElement;
    if (canTemplate) {
        fragment = generateCustomElementTemplate(css);
    } else {
        fragment = generateCustomElementFragment(css);
    }

    return function (element: DSCustomElement): HTMLElement {
        if (element.shadowRoot) {
            return element.shadowRoot.querySelector('div')!;
        }
        
        if (element.attachShadow) {
            element.attachShadow({ mode: 'open' });
        } else {
            Object.assign(element, {shadowRoot: element});
        }

        const shadowContent = document.importNode(fragment, true);

        if (!canTemplate) {
            const styleTag = shadowContent.querySelector('style');
            (styleTag as any).sheet.cssText = css;
        }

        const shadowRoot = element.shadowRoot!;
        shadowRoot.appendChild(shadowContent);
        const wrappingDiv = shadowRoot.querySelector('div')!;

        return wrappingDiv;
    }
}

function generateCustomElementFragment(css: string): DocumentFragment {
    const fragment = document.createDocumentFragment();
    
    const styleTag = document.createElement('style');
    styleTag.appendChild(document.createTextNode(css));

    const rootDiv = document.createElement('div');
    rootDiv.className = 'root';

    fragment.appendChild(styleTag);
    fragment.appendChild(rootDiv);

    return fragment;
}

function generateCustomElementTemplate(css: string): DocumentFragment {
    const template = document.createElement('template');
    template.innerHTML = `<style>${css}</style><div class="root"></div>`;

    return template.content;
}